import { useSignal } from "@preact/signals";
import { fetchOrError } from "@/app/utils.ts";
import { useEffect } from "preact/hooks";
import { useAppData } from "@/components/App.tsx";

export interface ChatIndex {
  uuid: string;
  title: string;
  created: string;
  updated: string;
}

export function History() {
  const appData = useAppData();
  const chatIndex = useSignal<ChatIndex[] | null>(null);
  const timeout = useSignal<number | null>(null);

  useEffect(() => {
    loadChatIndex();
  }, []);

  useEffect(() => {
    if (!timeout.value) setTimeout(() => loadChatIndex(), 5000);
    return () => clearTimeout(timeout.value!);
  }, [appData.chatData.value])

  async function loadChatIndex() {
    if (appData.user.value == null) return;
    chatIndex.value = await fetchOrError('/api/history');
    if (timeout.value) clearTimeout(timeout.value);
    timeout.value = null;
  }



  const sorted = chatIndex.value?.sort((a, b) => new Date(b.updated).getTime() - new Date(a.updated).getTime());

  return <dialog class="history" open={false}>
    <div class="container">
      <form method='dialog'>
        <span>Chat History</span>
        <button class="close"></button>
      </form>
      <div class="chats">
        {sorted?.map(chat => <a class="chat" key={chat.uuid} href={`${appData.siteURL}/chat/${chat.uuid}`}>
          {chat.title}
        </a>)}
      </div>
    </div>
  </dialog>
}